// extracted by mini-css-extract-plugin
export const root = "social-media-module--root--36-_X";
export const item = "social-media-module--item--14f24";
export const link = "social-media-module--link--2orAW";